import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import KlarnaStepComponentiOS from './klarnaStep.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='stepDelegate' subtitle='PrimerHeadlessSteppableDelegate' mdxType="Item">
      <p>
	Whenever <a href={`#klarnacomponent.start`}>start</a> or <a href={`#klarnacomponent.submit`}>submit</a> methods are
	called, <code>stepDelegate</code> will trigger the next step in case the call to the mentioned method was successful.
      </p>
      <p>
	In the case of KLARNA, the steps will be of type <code>KlarnaStep</code>.
      </p>
      <p>
	<code>KlarnaStep</code> is an enum holding different output data for specific steps.
      </p>
      <KlarnaStepComponentiOS mdxType="KlarnaStepComponentiOS" />
      <p>{`Example:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`  func didReceiveStep(step: KlarnaStep)
`}</code></pre>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      